import React from "react";
import { Link } from "react-router-dom";

interface SmartLinkProps extends React.ComponentProps<typeof Link> {
  newTab?: boolean;
  href?: string; // if component also supports plain <a>
}

export function SmartLink(props: SmartLinkProps) {
  const { newTab, to, href, children, ...rest } = props;

  const target = newTab ? "_blank" : rest.target;
  const rel = newTab ? "noopener noreferrer" : rest.rel;

  // Internal route (use `to`)
  if (to) {
    return (
      <Link
        to={to}
        {...rest} // newTab removed
        target={target}
        rel={rel}
      >
        {children}
      </Link>
    );
  }

  // External link (use `href`)
  if (href) {
    return (
      <a
        href={href}
        {...rest} // newTab removed
        target={target}
        rel={rel}
      >
        {children}
      </a>
    );
  }

  return <>{children}</>;
}

export default SmartLink;
